import { ChangeDetectionStrategy, Component, Signal } from '@angular/core';
import { DotLoader } from '@src/shared/feedback/loader/dot-loader.component';
import { ProgressBar } from '@src/shared/presentational/progress_bar/progress-bar.component';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { ModalLayoutComponent } from '../base-modal/modal-layout/modal-layout.component';

@Component({
  selector: 'app-progress-modal',
  imports: [ModalLayoutComponent, ProgressBar, DotLoader],
  templateUrl: './progress-modal.component.html',
  styleUrl: './progress-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressModalComponent extends BaseModalComponent<{
  message: string;
  autoClose?: number;
  progress: Signal<number>;
  progress_message: Signal<string>;
}> {
  content = this.modaldata;
  constructor() {
    super();
    if (this.modaldata()?.autoClose && this.modaldata()?.autoClose > 0) {
      setInterval(() => {
        if (this.content().progress() === 100) {
          this.close();
        }
      }, this.content().autoClose * 1000);
    }
  }
}
